//+=+=+=+ LOCAL ENV +=+=+=+//
// export const msalConfig = {
//     auth: {
//         clientId: "5a7d83b9-6610-434a-b111-4a9ba6477e94",
//         // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
//         authority: "https://login.microsoftonline.com/f7fc1ab8-3bf8-454e-ad3f-d0849b6ece8b",
//         redirectUri: "https://localhost:44498/",
//         postLogoutRedirectUri: "https://localhost:44498/"
//     },
//     cache: {
//         cacheLocation: "sessionStorage", // This configures where your cache will be stored
//         storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
//     },
//     forceRefresh: true
// };

//+=+=+=+ SYNTAX AZURE ENV +=+=+=+//
//export const msalConfig = {
//    auth: {
//        clientId: "5a7d83b9-6610-434a-b111-4a9ba6477e94",
//        // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
//        authority: "https://login.microsoftonline.com/f7fc1ab8-3bf8-454e-ad3f-d0849b6ece8b",
//        redirectUri: "https://simsweb.azurewebsites.net/",
//        postLogoutRedirectUri: "https://simsweb.azurewebsites.net/"
//    },
//    cache: {
//        cacheLocation: "sessionStorage", // This configures where your cache will be stored
//        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
//    }
//};

//+=+=+=+ PORTBROOK AZURE UAT +=+=+=+//
//export const msalConfig = { 
//    auth: {
//        clientId: "72615cac-7155-401e-9093-1c51b02df6be",
//        // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
//        authority: "https://login.microsoftonline.com/4859a179-c3ab-4d07-b46f-7e9ca7716b34",
//        redirectUri: "https://sims-uat.azurewebsites.net",//"https://localhost:44498/",//  , 
//        postLogoutRedirectUri: "https://sims-uat.azurewebsites.net",// "https://localhost:44498/",//
//    },
//    cache: {
//        cacheLocation: "sessionStorage", // This configures where your cache will be stored
//        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
//    },
//    forceRefresh: true

//};

//+=+=+=+ PORTBROOK AZURE PRODUCTION +=+=+=+//
export const msalConfig = {
   auth: {
       clientId: "eb502ae9-a2fc-4885-ab13-b468a13f06bf",
       // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
       authority: "https://login.microsoftonline.com/4859a179-c3ab-4d07-b46f-7e9ca7716b34",
       redirectUri: "https://pbsims.azurewebsites.net", 
       postLogoutRedirectUri: "https://pbsims.azurewebsites.net",
   },
   cache: {
       cacheLocation: "sessionStorage", // This configures where your cache will be stored
       storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
   },
   forceRefresh: true

};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: ["User.Read", "offline_access"]
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "Enter_the_Graph_Endpoint_Here/v1.0/me"
};